import React, { Component } from "react";
import {
  Typography,
  CircularProgress,
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent
} from "@material-ui/core";
import ProfileDialog from "../ProfileDialog/ProfileDialog";
import SettingsDialog from "../SettingsDialog/SettingsDialog";
import GroupDialog from "../GroupDialog/GroupDialog";
import PrivateDialog from "../PrivateDialog/PrivateDialog";

class DialogHost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    this.toggleLoading = this.toggleLoading.bind(this);
  }

  toggleLoading() {
    this.setState({ loading: !this.state.loading });
  }

  render() {
    return (
      <Dialog
        maxWidth="xs"
        fullWidth
        onClose={this.props.toggleDialog.bind(this, "close")}
        open={this.props.dialogOpen}
        disableBackdropClick={this.state.loading}
        disableEscapeKeyDown={this.state.loading}
        style={{ zIndex: 1350 }}
      >
        <Box p={2} display="flex" justifyContent="space-between">
          <Typography variant="h5">{this.props.dialogTitle}</Typography>
          {this.state.loading && <CircularProgress size={30} />}
        </Box>

        <DialogContent dividers>
          {this.props.dialogName === "Profile" && (
            <ProfileDialog
              toggleLoading={this.toggleLoading}
              toggleAlert={this.props.toggleAlert}
              user={this.props.user}
              userDeleted={this.props.userDeleted}
            />
          )}
          {this.props.dialogName === "Settings" && (
            <SettingsDialog
              toggleLoading={this.toggleLoading}
              toggleAlert={this.props.toggleAlert}
              user={this.props.user}
              appearance={this.props.appearance}
            />
          )}
          {this.props.dialogName === "Group" && (
            <GroupDialog
              toggleLoading={this.toggleLoading}
              toggleAlert={this.props.toggleAlert}
              user={this.props.user}
              group={this.props.group}
              dialogInfo={this.props.dialogInfo}
              chatDeleted={this.props.chatDeleted}
            />
          )}
          {this.props.dialogName === "Private" && (
            <PrivateDialog
              toggleLoading={this.toggleLoading}
              toggleAlert={this.props.toggleAlert}
              user={this.props.user}
              chat={this.props.chat}
              dialogInfo={this.props.dialogInfo}
              chatDeleted={this.props.chatDeleted}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.loading}
            color="primary"
            onClick={this.props.toggleDialog.bind(this, "close")}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DialogHost;
